import { ToolConfig } from '@/types/tool';

// Import all tool configs
import { homeConfig } from './home/config';
import { base64ConverterConfig } from './base64-converter/config';
import { jsonEditorConfig } from './json-editor/config';
import { jsonFormatterConfig } from './json-formatter/config';
import { jwtToolkitConfig } from './jwt-toolkit/config';
import { epochConverterConfig } from './epoch-converter/config';

// Central registry - add new tools here
export const toolRegistry: ToolConfig[] = [
  homeConfig,
  base64ConverterConfig,
  jsonEditorConfig,
  jsonFormatterConfig,
  jwtToolkitConfig,
  epochConverterConfig,
];

// Helper to get tool by ID
export const getToolById = (id: string): ToolConfig | undefined => {
  return toolRegistry.find((tool) => tool.id === id);
};

// Helper to get tool by path
export const getToolByPath = (path: string): ToolConfig | undefined => {
  return toolRegistry.find((tool) => tool.path === path);
};

// Get all tools except home
export const getNavigableTools = (): ToolConfig[] => {
  return toolRegistry.filter((tool) => tool.id !== 'home');
};
